<template>
  <div :class="checkMobileStatus ? 'mobile-view' : 'web-view'">
    <div class="feed-box mt-0" v-bind:class="[post.PostID]" v-if="!isHome">
      <div v-if="post.PostStatus === 'Draft'" style="text-align: left">
        <div style="width: 100%; background: #eb5757; padding: 5px 10px; color: #ffffff; border-radius: 4px 4px 0px 0px">
          <i class="fa fa-pencil" aria-hidden="true" style="margin-right: 10px"></i>
          <span>Draft</span>
        </div>
      </div>
      <div class="image-wrapper" v-if="!isNull(post.postFiles)">
        <ul v-if="!checkMobileStatus" class="image-grid-1">
          <li
            style="cursor: pointer"
            class="postFile__item"
            v-for="(obj_Images, index) in post.postFiles"
            :key="obj_Images.id"
            :class="[
              {
                isFile:
                  isImageByExt(obj_Images) === false && !isVideo(obj_Images) && !isAudio(obj_Images) && obj_Images.PostItemFileExt.toLowerCase() !== '.pdf',
              },
              'image-grid-item-1',
            ]"
            v-if="index < 1"
          >
            <div v-if="isImageByExt(obj_Images)" class="w-100">
              <i class="material-icons">search</i>
              <img
                slot="img"
                class="nonM card-img-top d-block img-fluid"
                :src="getApiImage(obj_Images)"
                :id="'ITEMPOSTID_' + obj_Images.PostItemID"
                @click="showPreviewModal(post)"
                :alt="post.PostPorDtlTitle"
                style="height: 100%; width: 100%; object-fit: cover"
              />
            </div>
            <div
              class="nonM card-img-top d-block img-fluid w-100 video"
              :class="'video-thumbnail-' + obj_Images.PostItemID"
              v-else-if="isVideo(obj_Images)"
              @click="showPreviewModal(post)"
            >
              <K2Icon name="video_library" font-size="60px" />
              <!--                            <span v-if="!showThumb">Generating...</span>-->
              <!--                            <img slot="img" class="nonM card-img-top d-block img-fluid" @error="handleNotFoundError"-->
              <!--                                 :src="obj_Images.Thumbnail" :id="'ITEMPOSTID_'+obj_Images.PostItemID"-->
              <!--                                 v-else-if="obj_Images.Thumbnail && showThumb"-->
              <!--                                 :alt="post.PostPorDtlTitle" style="height: 100%; width: 100%; object-fit: cover;"/>-->
              <!--                            <K2Video :src="getApiImage(obj_Images, true)" v-else/>-->
            </div>
            <audio
              class="nonM card-img-top d-block img-fluid w-100"
              v-else-if="isAudio(obj_Images)"
              @click="showImageModal(index)"
              controls
              style="object-fit: contain"
            >
              <source :src="obj_Images.FilePath" :type="obj_Images.PostItemFileType" />
            </audio>
            <div v-else @click="showPreviewModal(post)">
              <pdf class="pdf preview" :src="obj_Images.FilePath" style="max-width: 100%; height: 400px; overflow: auto"></pdf>
            </div>
          </li>
        </ul>
      </div>
      <div class="image-wrapper" v-if="isNull(post.postFiles)">
        <ul v-if="!checkMobileStatus" class="image-grid-1">
          <li style="cursor: pointer; background: #f1f1f1" class="postFile__item image-grid-item-1">
            <div class="w-100">
              <i class="material-icons">search</i>
              <img
                slot="img"
                class="nonM card-img-top d-block img-fluid"
                :src="assets.image.emptyThumb"
                @click="showPreviewModal(post)"
                style="height: 100%; width: 100%; object-fit: cover"
              />
            </div>
          </li>
        </ul>
      </div>
      <div
        v-if="
          !isNull(post.postFiles) &&
          userType === 'Parent' &&
          (this.arr_SchIDs.includes('SCH201400000553') || (!isNull(post.StudentPDPA) && post.StudentPDPA === 'Yes'))
        "
        style="margin: 10px 10px; text-align: left"
      >
        <a style="color: #585388; cursor: pointer; font-size: 12px" @click="downloadItem(post.postFiles)">
          <span style="margin-right: 5px"><i class="fa fa-download" aria-hidden="true"></i></span>{{ lang('Download') }}
        </a>
      </div>
      <div
        v-if="!isNull(post.postDevelopment)"
        style="text-align: left; background: #f3f6f8; border-radius: 4px; max-height: 200px; overflow: auto; display: none"
      >
        <div style="width: 100%; background: #e5ecf1; padding: 10px">
          <img :src="assets.image.logoIcon" style="width: 20px; height: 20px" />
          <span style="vertical-align: text-top; margin-left: 10px; font-weight: bold">{{ lang('Learning Goals') }}</span>
        </div>
        <div style="width: 100%; padding: 5px 10px" v-for="(pDevelopment, index) in post.postDevelopment" :key="pDevelopment">
          <img :src="assets.image.checked" style="width: 15px; height: 15px" />
          <span style="color: #5c6b77; font-size: 12px; margin-left: 10px">{{ pDevelopment.PostUpLMIndicator }}</span>
        </div>
      </div>
      <div class="lds-ellipsis" v-if="isLoad">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="content" style="position: relative">
        <div class="border-bottom mx-3 pt-2" style="">
          <!--<span style="white-space: pre-line;">{{post.PostContent}}</span>-->
          <K2Row class="border-bottom mb-3" :space-between="true">
            <strong class="feed-subtitle">{{ post.PostUpdDtlTitle }}</strong>
            <K2PrintFromURL :post="post" />
          </K2Row>

          <div
            class="post-content"
            style="white-space: pre-line; word-break: break-word"
            v-if="post.PostContent !== 'null'"
            v-html="post.PostContent || post.PostUpdDtlDescription"
          ></div>

          <small class="date py-2">
            {{ convertDatetimeFormat(post.PostCreatedDate) }} . {{ post.CONname }}
            <!--{{post.PostCreatedDate_convert}}-->
          </small>
          <FeedStudents :parentPost="post" :passPostTagLists="post.PostTagLists" @handleSelectedTags="handleSelectedTags" @setLoad="setLoad" />
          <K2Row class="mt-2 pb-2" space-between="true">
            <a @click="showPreviewModal(post)">{{ lang('More') }}...</a>
            <K2Icon v-if="isPDF(post.postFiles)" class="feedPdfDownload" name="file_download" link="true" @onclick="handleDownloadPDF(post.postFiles)" />
          </K2Row>
        </div>
      </div>
      <div class="total-reaction-container" v-if="!hideComment">
        <div style="display: inline-block; margin-right: 5px" v-if="!isNull(post.postReaction)">
          <div v-if="post.postReaction.length > 0">
            <img
              class="total-reaction-img-list"
              :key="eachKey.id"
              v-for="(eachReaction, eachKey) of reactionGroupby(post.postReaction, 'PoReaType')"
              :src="checkReactionIcon(eachKey)"
            />
          </div>
        </div>
        <K2Row space-between="true">
          <div
            class="reaction-function-container"
            v-if="!hideComment"
            :class="!isNull(post.postReaction) || (!isNull(post.postSeen) && userType !== 'Parent') ? '' : 'left'"
          >
            <div class="moreAction">
              <span class="reaction-popover">
                <input
                  :id="post.PostID + '-LIKE-default'"
                  type="checkbox"
                  @change="e => togglePostReaction(eachReaction && eachReaction.reactionNameCN, e)"
                  value="LIKE"
                  hidden="hidden"
                />
                <label
                  :for="post.PostID + '-LIKE-default'"
                  class="reaction-label"
                  style="font-weight: normal; font-size: 12px"
                  @click="showReactionModal(post.PostReactions.length)"
                >
                  <img :src="assets.icon.likeThumb" height="15" class="me-2" />
                  <span v-if="post.PostReactions && post.PostReactions.length > 0"> {{ post.PostReactions.length }}</span>
                  <span v-else> 0</span>
                  {{ lang('LIKE') }}
                </label>
              </span>

              <!--reaction list-->
              <div class="reaction-list-container">
                <div class="single-reaction" :class="eachReaction.reactionName.toLowerCase() + '-reaction'" v-for="eachReaction of arrobj_ReactionList">
                  <input
                    :id="post.PostID + '-' + eachReaction.reactionName"
                    type="checkbox"
                    @change="e => togglePostReaction(eachReaction.reactionNameCN, e)"
                    :value="eachReaction.reactionName"
                    :checked="getUserSelectedReaction(eachReaction.reactionName)"
                    hidden="hidden"
                  />
                  <label :for="post.PostID + '-' + eachReaction.reactionName">
                    <img :src="eachReaction.reactionIcon" />
                    <p>{{ eachReaction.reactionNameCN }}</p>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div style="display: inline-block" v-if="isNull(post.postReaction)"></div>
          <span class="comment-count" v-if="post.PostAllowComment === 'Yes'">
            <span style="font-size: 12px">{{ commentCount }} comment(s)</span>
          </span>
          <div style="display: inline-block" v-if="!isNull(post.PostSeens) && userType !== 'Parent'">
            <span @click="showPostSeenModal()" style="cursor: pointer; font-size: 12px; color: grey">
              <span v-if="!isNull(post.postReaction)">| </span>
              {{ lang('Seen by') }} {{ post.PostSeens.length }}
            </span>
          </div>
        </K2Row>
      </div>
      <div class="comment_wrapper transition-box" v-if="!hideComment && post.PostAllowComment === 'Yes'" style="display: none">
        <form class="form-style">
          <input type="text" class="form-control d-none commentPostID" v-model="commentPostID" />
          <vs-input :label-placeholder="lang('Comment')" v-model="commentPostContent" class="addComment" v-on:keyup.enter="submitComment(post.PostID)" />
          <div class="btn btn-primary" @click="submitComment(post.PostID)"><i class="fa fa-paper-plane" aria-hidden="true"></i></div>
        </form>
        <div class="commentWrap" v-if="post.commentItems" :class="{ 'is-collapsed': post.collapsed }">
          <transition-group name="top">
            <div
              class="comment__item"
              v-if="post.commentItems && commentIndex <= post.commentItems.length && post.commentItems[commentIndex - 1]"
              v-for="commentIndex in commentsToShow"
              :key="post.commentItems[commentIndex - 1].PoCmID"
              style="position: relative"
            >
              <div class="rightCommentContainer col-md-12">
                <div class="commentItem__header">
                  <div class="comment__name">
                    <span>{{ post.commentItems[commentIndex - 1].commentOwnerName }}</span>
                    <!--                                    commentOwnerName-->
                  </div>
                  <div class="commentPostContent_show" v-if="checkidcomment !== post.commentItems[commentIndex - 1].PoCmID">
                    {{ post.commentItems[commentIndex - 1].PoCmContent }}
                  </div>
                  <div class="comment__date">
                    <div class="post-comment-actionGroup" v-if="post.commentItems[commentIndex - 1].CONid === feedUserID">
                      <el-button
                        class="save"
                        type="text"
                        slot="reference"
                        @click="saveClick(post.commentItems[commentIndex - 1].PoCmID, post.commentItems[commentIndex - 1].PoCmContent)"
                        :class="{ 'd-none': readonly === true || checkidcomment !== post.commentItems[commentIndex - 1].PoCmID }"
                      >
                        {{ lang('Save') }}
                      </el-button>
                      <el-button class="edit" type="text" slot="reference" @click="editClick(post.commentItems[commentIndex - 1].PoCmID)" v-if="showEdit">
                        {{ lang('Edit') }}
                      </el-button>
                      .
                      <el-button
                        class="delete"
                        type="text"
                        slot="reference"
                        @click="
                          emitShowDeleteModal(post.commentItems[commentIndex - 1].PoCmID, post.commentItems[commentIndex - 1].PoCmContent, post.PostID, post)
                        "
                      >
                        {{ lang('Delete') }}
                      </el-button>
                      .
                    </div>
                    <span>{{ post.commentItems[commentIndex - 1].PoCmCreatedDate_convert }}</span>
                  </div>
                </div>
                <textarea
                  v-if="readonly === false && checkidcomment === post.commentItems[commentIndex - 1].PoCmID"
                  type="text"
                  class="comment__content"
                  id="commentPostContent"
                  v-model="post.commentItems[commentIndex - 1].PoCmContent"
                  v-bind:readonly="readonly"
                  :class="{ editable: readonly === false && checkidcomment === post.commentItems[commentIndex - 1].PoCmID }"
                ></textarea>
                <div
                  @mouseover="mouseOverComment(post.commentItems[commentIndex - 1].PoCmID)"
                  @mouseleave="mouseLeaveComment(post.commentItems[commentIndex - 1].PoCmID)"
                  style="position: relative"
                >
                  <div :class="post.commentItems[commentIndex - 1].PoCmID + 'comment-reaction-container'" style="display: inline-block; padding-right: 5px">
                    <span class="comment-reaction-popover">
                      <input
                        :id="post.commentItems[commentIndex - 1].PoCmID + '-LIKE'"
                        type="checkbox"
                        @change="toggleCommentReaction($event, post.commentItems[commentIndex - 1])"
                        value="LIKE"
                        hidden="hidden"
                      />
                      <label
                        :for="post.commentItems[commentIndex - 1].PoCmID + '-LIKE'"
                        :class="
                          post.commentItems[commentIndex - 1].commentReactions
                            ? post.commentItems[commentIndex - 1].commentReactions.commentReactionSelected
                              ? 'comment-selected'
                              : ''
                            : ''
                        "
                      >
                        {{ lang('LIKE') }}
                      </label>
                    </span>
                  </div>
                  <div class="total-each-comment-reaction" v-if="post.commentItems[commentIndex - 1].commentReactions">
                    <img
                      style="width: 20px; background: transparent"
                      v-if="post.commentItems[commentIndex - 1].commentReactions.length > 0"
                      v-for="(eachCommentReactionSelected, eachCommentKey) of reactionGroupby(
                        post.commentItems[commentIndex - 1].commentReactions,
                        'PoReaType',
                      )"
                      :src="checkReactionIcon(eachCommentKey)"
                    />
                    <span style="margin-left: 5px; color: #9a9a9a">{{ post.commentItems[commentIndex - 1].commentReactions.length }}</span>
                  </div>
                  <div class="comment-reaction-list-container" :id="post.commentItems[commentIndex - 1].PoCmID + '-comment-reaction-list'">
                    <div
                      class="single-comment-reaction"
                      :class="eachReaction.reactionName.toLowerCase() + '-reaction'"
                      v-for="eachReaction of arrobj_ReactionList"
                    >
                      <input
                        :id="post.commentItems[commentIndex - 1].PoCmID + '-' + eachReaction.reactionName"
                        type="checkbox"
                        @change="toggleCommentReaction($event, post.commentItems[commentIndex - 1])"
                        :value="eachReaction.reactionName"
                        :checked="getUserSelectedCommentReaction(eachReaction.reactionName, post.commentItems[commentIndex - 1])"
                        hidden="hidden"
                      />
                      <label :for="post.commentItems[commentIndex - 1].PoCmID + '-' + eachReaction.reactionName">
                        <img :src="eachReaction.reactionIcon" />
                        <p>{{ eachReaction.reactionNameCN }}</p>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition-group>
          <button @click="commentsToShow += 2" v-if="post.commentItems && post.commentItems.length > commentsToShow">
            {{ lang('Load More') }}
          </button>
        </div>
      </div>
    </div>
    <ul class="feed-box mt-0" v-bind:class="[post.PostID]" v-if="isHome">
      <li>
        <div class="image-wrapper">
          <ul>
            <li class="" v-for="postFile in post.postFiles" :key="postFile.ID">
              <img
                :src="`data:image/jpg;base64, ${postFile.PostItemFile}`"
                :class="{ 'post-disabled': postFile.PostItemStatus !== 'Active' }"
                v-if="postFile.PostItemFile"
              />
              <img
                :src="postFile.PostItemPath"
                :class="{ 'post-disabled': postFile.PostItemStatus !== 'Active' }"
                v-else-if="checkIfImage(postFile.PostItemPath)"
              />
            </li>
          </ul>
        </div>
        <span>
          <strong>{{ post.CONname }}</strong>
          <small class="date"><i class="fa fa-clock-o" aria-hidden="true"></i><i class="fa fa-clock-o" aria-hidden="true"></i>{{ post.PostCreatedDate }}</small>
          {{ post.PostContent }}
        </span>
      </li>
    </ul>
    <b-modal id="modal_EditComponent" ref="modal_EditComponent" size="lg" hide-footer :title="lang('Edit') + lang('Post')" @hidden="hideEditModal">
      <component @result="displayResult" :is="obj_SelectedComponent" :post="post"></component>
    </b-modal>

    <b-modal id="imageModal" ref="imageModal" hide-footer hide-header>
      <div style="text-align: right">
        <span @click="hideImageModal()" style="display: inline-block; padding: 0px 5px; font-weight: bold; cursor: pointer">X</span>
      </div>
      <div v-for="(obj_Images, imgIndex) of post.postFiles" :key="obj_Images.id">
        <div v-if="obj_Images.isSlide">
          <div class="mySlides">
            <img
              slot="img"
              class="card-img-top d-block img-fluid"
              :src="obj_Images.FilePath"
              v-if="isImageByExt(obj_Images)"
              :alt="post.PostPorDtlTitle"
              style="max-height: 100%; height: 100%; width: auto; object-fit: scale-down; margin: 0 auto"
            />
            <div v-if="isVideo(obj_Images)">
              <img
                slot="img"
                class="card-img-top d-block img-fluid"
                :src="obj_Images.Thumbnail"
                v-if="obj_Images.Thumbnail"
                :alt="post.PostPorDtlTitle"
                style="max-height: 100%; height: 100%; width: auto; object-fit: scale-down; margin: 0 auto"
              />
              <LazyVideo
                slot="img"
                class="card-img-top d-block img-fluid"
                v-else
                style="height: 100%; margin: 0 auto"
                :src="obj_Images.FilePath"
                controlsList="nodownload"
              />
            </div>

            <audio class="d-block" v-if="isAudio(obj_Images)" controls style="margin: 0 auto; max-width: 100%">
              <source :src="obj_Images.FilePath" :type="obj_Images.PostItemFileType" />
            </audio>
            <pdf
              v-if="!isImageByExt(obj_Images) && !isVideo(obj_Images) && !isAudio(obj_Images) && obj_Images.PostItemFileExt.toLowerCase() === '.pdf'"
              v-for="i in obj_Images.numPages"
              :key="i"
              :page="i"
              style="display: block; width: 100%; margin: 0 auto"
              :src="obj_Images.pageOfSrc"
            >
            </pdf>
          </div>
          <div class="row" style="justify-content: center; margin: 10px 0px 0px 0px">
            <div style="margin: 7px 0px; font-weight: bold; color: #2b2626">{{ imgIndex + 1 }}/{{ post.postFiles.length }}</div>
            <button class="btn" @click="showDivs('prev')"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
            <button class="btn" @click="showDivs('next')"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>
            <button
              class="btn"
              @click="downloadSingleItem(obj_Images)"
              v-if="
                !isNull(post.postFiles) &&
                userType === 'Parent' &&
                (arr_SchIDs.includes('SCH201400000553') || (!isNull(post.StudentPDPA) && post.StudentPDPA === 'Yes'))
              "
            >
              <i class="fa fa-download" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="reactionModal" ref="reactionModal" size="sm" hide-footer :title="lang('Reaction by')" @hidden="hideReactionModal">
      <div v-for="reaction in post.PostReactions" style="margin-bottom: 20px; border-bottom: 1px solid #f7f7f7; padding: 5px">
        <span>{{ reaction.CONname || reaction.PoReaCreatedBy }}</span>
        <img class="total-reaction-img-list" style="float: right" :src="checkReactionIcon(reaction.PoReaType)" />
      </div>
    </b-modal>
    <b-modal id="postSeenModal" ref="postSeenModal" size="sm" hide-footer :title="lang('Seen by')" @hidden="hidePostSeenModal">
      <div v-for="seen in post.PostSeens" style="margin-bottom: 20px; border-bottom: 1px solid #f7f7f7; padding: 5px">
        <div class="row" style="margin: 0px">
          <span>{{ seen.CONname }}</span>
          <!--                    <span style="margin-left: auto;">{{seen.NotiModifiedOn_convert}}</span>-->
        </div>
      </div>
    </b-modal>

    <ActivityPreview
      :isBroadcast="isBroadcast"
      :parentPost="previewPost"
      isPublished="true"
      @handleClose="handleClose"
      @onConfirm="handleClose"
      @deletePost="deletePost"
      @handleUpdates="handleUpdates"
      :modal="modal"
      :approverPostNotShow="approverPostNotShow"
      :post="post"
      :feedUserID="feedUserID"
      :passSchool="school"
    />
  </div>
</template>
<script>
import isImage from 'is-image'
import DataSource from '../../../../data/datasource'
import AlertComponent from '../../../../components/alertComponent'
import Cookies from 'js-cookie'
import { lang } from '../../../../locale'
import moment from 'moment'
import $ from 'jquery'
import pdf from 'vue-pdf'
import Vue from 'vue'
import VueLazyLoadVideo from 'vue-lazyload-video'
import assets from '../../../../assets/assets'
import FeedStudents from './FeedStudents'
import K2Modal from '../../../../uiComponents/k2Modal/k2Modal'
import K2Row from '../../../../uiComponents/k2Row/k2Row'
import K2Icon from '../../../../uiComponents/k2Icon/k2MAIcon'
import K2Heading from '../../../../uiComponents/k2Heading/k2Heading'
import K2Button from '../../../../uiComponents/k2Button/k2Button'
import ActivityPreview from './activityPreview'
import uiVariable from '../../../../config/uiVariable'
import K2Confirm from '../../../../uiComponents/k2Confirm/k2Confirm'
import K2Video from '../../../../uiComponents/k2Video/k2Video'
import axios from 'axios'
import K2PrintFromURL from '../../module/K2PrintFromURL'
import { getActivityImageBase } from '@/helper/util_custom'

Vue.use(VueLazyLoadVideo)

export default {
  name: 'FeedItem',
  components: {
    K2PrintFromURL,
    K2Video,
    K2Confirm,
    ActivityPreview,
    K2Button,
    K2Heading,
    K2Icon,
    K2Row,
    K2Modal,
    FeedStudents,
    AlertComponent,
    pdf,
  },
  data() {
    return {
      assets: assets,
      uiVariable: uiVariable,
      reactionCount2: '',
      commentCount: '',
      show3: false,
      commentPostContent: '',
      readonly: '',
      showThumb: true,
      checkidcomment: null,
      systemmsgError: null,
      commentPostID: '',
      deleteModalShow: false,
      showEdit: true,
      deleteCmId: null,
      deleteCmContent: null,
      deleteCmPostId: null,
      deletePostModalShow: false,
      obj_SelectedComponent: false,
      result: '',
      post: [
        {
          CONname: '',
          PostContent: '',
          PostCreatedBy: '',
          PostCreatedDate: '',
          PostID: '',
          PostType: '',
          PostUpdDtlDescription: '',
          ProfileImage: '',
          RowNumber: '',
          collapsed: true,
          commentItems: [],
          commentPostID: '',
          postFiles: '',
          postReaction: [],
          countImageFile: '',
          postKeyTag: [],
          postDevelopment: [],
          postSeen: [],
        },
      ],
      str_TimerID: '',
      likeCount: 0,
      isFile: false,
      approverPostNotShow: true,
      remainingImage: '',

      feedUserID: Cookies.get('userIDSession'),
      commentsToShow: 2,

      isHoverReaction: false,
      arrobj_ReactionList: [
        {
          reactionName: 'LIKE',
          reactionNameCN: lang('LIKE'),
          reactionIcon: assets.emotion.like,
          isCheck: false,
        },
        {
          reactionName: 'LOVE',
          reactionNameCN: lang('LOVE'),
          reactionIcon: assets.emotion.love,
          isCheck: false,
        },
        {
          reactionName: 'WOW',
          reactionNameCN: lang('WOW'),
          reactionIcon: assets.emotion.wow,
          isCheck: false,
        },
        {
          reactionName: 'HAHA',
          reactionNameCN: lang('HAHA'),
          reactionIcon: assets.emotion.funny,
          isCheck: false,
        },
        // {"reactionName": "SAD", "reactionNameCN": lang("SAD"), "reactionIcon": assets.emotion.sad, "isCheck": false}
      ],
      obj_SelectedReaction: [],
      reactionSelectedText: '',

      obj_SelectedCommentReaction: [],
      totalReactionList: [],
      commentReactionSelected: 0,

      notificationUserToken: '',
      checkMobileStatus: false,

      isLoad: false,
      userType: '',
      parentDMMsg: '',
      singlePostLink: '',
      arr_SchIDs: [],

      videoClick: false,

      porDevelopmentObjectValue: [
        // {
        //     prop: "Domain",
        //     label: lang("Domain")
        // },
        {
          prop: 'PostUpLMIndicator',
          label: lang('Goals'),
        },
        // {
        //     prop: "Indicator",
        //     label: lang("Indicator")
        // }
      ],

      imgModalSlide: 0,
      currentSlide: 1,
      modal: null,
      previewPost: null,
      studentList: [],
      levelList: [],
      classList: [],
      school: null,
      postReaction: [],
      layoutConfig: {},
    }
  },
  mounted() {
    if (!this.isNull(this.approverPost) && this.approverPost === 'YES') {
      this.approverPostNotShow = false
    }

    if (!this.isNull(this.parentPost)) {
      this.initPost()
    }

    $(document)
      .off('contextmenu', 'video')
      .on('contextmenu', 'video', e => {
        e.preventDefault()
      })

    this.isMobile()
  },
  props: ['parentPost', 'commentitemSubmit', 'hideComment', 'isHome', 'hideSubmenu', 'loadPosts', 'approverPost', 'index', 'sendMsg', 'isBroadcast'],
  methods: {
    lang,
    sleep(milliseconds) {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
    },
    showImageModal(imgIndex) {
      if (!this.isNull(this.post.postFiles)) {
        this.post.postFiles.forEach(pdfFiles => {
          if (pdfFiles.PostItemFileExt.toLowerCase() === '.pdf') {
            let src = pdf.createLoadingTask(pdfFiles.FilePath)
            pdfFiles.pageOfSrc = src
            src.promise.then(pdf => {
              pdfFiles.numPages = pdf.numPages
            })
          }
        })
      }

      if (imgIndex !== '') {
        this.imgModalSlide = imgIndex
        this.showDivs('default')
      }

      this.$refs['imageModal'].show()
    },
    hideImageModal() {
      this.imgModalSlide = 0
      this.$refs['imageModal'].hide()
    },
    checkIfImage(file) {
      return isImage(file)
    },
    isMobile() {
      let screenWidth = window.innerWidth
      this.checkMobileStatus = screenWidth <= 770
    },
    showCommentTransition(CommentBtnPostID) {
      this.show3 = CommentBtnPostID
    },
    /*#region Download Item Functions*/
    pause(msec) {
      return new Promise((resolve, reject) => {
        setTimeout(resolve, msec || 1000)
      })
    },
    async downloadItem(val) {
      // this.$vs.loading();
      var indexA = 1
      for (let obj_SelectedItem of val) {
        let a = document.createElement('a')
        if (obj_SelectedItem.blobFilePath) {
          a.href = obj_SelectedItem.blobFilePath
        } else {
          a.href = obj_SelectedItem.FilePath
        }
        // a.href = obj_SelectedItem.FilePath;
        a.target = '_blank'
        a.download = ('download-' + indexA + obj_SelectedItem.PostItemFileExt).toString()
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        a.remove()
        if (indexA >= 10) {
          await this.pause(300)
        }
        indexA++
      }
      // this.$vs.loading.close();
    },
    async downloadSingleItem(obj_SelectedItem) {
      // this.$vs.loading()
      let a = document.createElement('a')
      if (obj_SelectedItem.blobFilePath) {
        a.href = obj_SelectedItem.blobFilePath
      } else {
        a.href = obj_SelectedItem.FilePath
      }
      // a.href = obj_SelectedItem.FilePath;
      a.download = ('download-1' + obj_SelectedItem.PostItemFileExt).toString()
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
      // this.$vs.loading.close();
    },
    getContentType(e) {
      let contentType = ''

      switch (e.GalFileExt.toUpperCase()) {
        case '.PDF':
          contentType += 'application/octet-stream'
          break
        default:
          contentType += e.GalFileType
          break
      }

      return contentType
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      //Credit to Jeremy Banks @ stackoverflow
      contentType = contentType || ''
      sliceSize = sliceSize || 512

      let byteCharacters = atob(b64Data)
      let byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize)

        let byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        let byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      return new Blob(byteArrays, { type: contentType })
    },
    /*#endregion*/
    async initPost() {
      this.isLoad = true
      try {
        this.obj_SelectedReaction = []
        /*this.resetPost();*/
        // let tempobj = !this.isNull(this.post.PostID) ? this.post : this.parentPost;
        this.post = this.parentPost

        if (this.post.ProfileImage !== '') {
          this.post.oriProfileImage = this.post.ProfileImage
          await this.urltoFile(this.post.ProfileImage, '', '')
            .then(blobFile => {
              var url = window.URL.createObjectURL(blobFile)

              this.post.ProfileImage = url
            })
            .finally(() => {})
        }

        if (this.post.PostItems) {
          this.post.postFiles = this.post.PostItems
          this.post.postFiles.forEach(file => {
            file.numPages = undefined
            if (file.PostItemFileExt.toLowerCase() === '.pdf') {
              // let src = pdf.createLoadingTask(`data:`+file.PostItemFileType+`;base64, ${file.PostItemFile}`);
              let src = pdf.createLoadingTask(file.FilePath)
              file.pageOfSrc = src
              src.promise.then(pdf => {
                file.numPages = pdf.numPages
              })
            }
            file.oriFilePath = file.FilePath
          })
        }

        this.$set(this.post, 'collapsed', true)

        // this.getComment();
        const countImageFile = this.post && this.post.postFiles && this.post.postFiles.length
        this.$set(this.post, 'countImageFile', countImageFile)

        this.remainingImage = this.post.countImageFile - 4

        this.isLoad = false
        if (this.post.PostReactions !== undefined) {
          this.post.PostReactions.forEach(object => {
            if (Cookies.get('userIDSession') === object.PoReaCreatedBy) {
              this.obj_SelectedReaction.push(object)
            }
          })

          let newReaction = []
          this.post.PostReactions.forEach(m => {
            const exist = newReaction.find(d => d.PoReaCreatedBy === m.PoReaCreatedBy && d.PoReaType === m.PoReaType)
            if (!exist) {
              newReaction.push(m)
            }
          })
          this.post.PostReactions = newReaction
        }

        if (this.post.PostLearningMoments.length > 0) {
          let newGoalList = []
          this.post.PostLearningMoments.forEach(x => {
            const exist = newGoalList.find(d => d.Domain === x.PostUpLMDomain)
            if (exist) {
              exist.ItemList.push(x)
            } else {
              newGoalList.push({
                Domain: x.PostUpLMDomain,
                ItemList: [x],
              })
            }
          })
          this.post.PostLearningMomentsGrouping = newGoalList
        }

        this.$emit('loadingclose', 'false')
        this.isLoad = false
      } catch (e) {
        console.log(e, 'initPost err')
      }
    },
    async getComment() {
      await DataSource.shared.getComment(this.post.PostID).then(comments => {
        if (comments.Table && comments.Table.length > 0) {
          comments.Table.sort((a, b) => {
            if (Date.parse(a.PoCmCreatedDate) > Date.parse(b.PoCmCreatedDate)) {
              return -1
            } else if (Date.parse(a.PoCmCreatedDate) < Date.parse(b.PoCmCreatedDate)) {
              return 1
            } else {
              return 0
            }
          })
        }

        this.$set(this.post, 'commentItems', comments.Table)

        if (!this.isNull(this.post.commentItems)) {
          for (let i = 0; i < this.post.commentItems.length; i++) {
            // console.log(comments.Table[i], "comment list");

            DataSource.shared.getPostReaction(comments.Table[i].PoCmID).then(commentReactions => {
              this.commentReactionSelected = 0

              if (commentReactions.Table) {
                commentReactions.Table.commentReactionSelected = commentReactions.Table.filter(x => Cookies.get('userIDSession') === x.PoReaCreatedBy).length

                this.$set(this.post.commentItems[i], 'commentReactions', commentReactions.Table)
              }
            })
          }

          this.commentCount = this.post.commentItems.length
        } else {
          this.commentCount = '0'
        }
      })
    },

    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },
    getApiImage(obj_Images, isVideo) {
      return getActivityImageBase(obj_Images, isVideo)
    },
    isImageByExt(obj_File) {
      let ext = String(obj_File.PostItemFileExt).toUpperCase()
      let isImage = false
      switch (ext) {
        case '.PNG':
        case '.JPG':
        case '.BMP':
        case '.GIF':
        case '.JPEG':
        case '.JFIF':
        case '.HEIC':
          isImage = true
          break
        default:
          isImage = false
          break
      }

      return isImage
    },
    // getLowSource(file) {
    //     return `data:image/jpg;base64, ${file.PostItemFileLow}`;
    // },
    handleNotFoundError() {
      this.showThumb = false
    },
    getMediumSource(file) {
      let SourceisImage = this.isImageByExt(file)
      if (SourceisImage === true) {
        return `data:image/jpg;base64, ${file.PostItemFileMedium}`
      } else {
        return `data:application/pdf;base64, ${file.PostItemFile}`
      }
    },
    getFile(file) {
      return `data:${file.PostItemFileType};base64,${file.PostItemFile}`
    },
    submitComment(commentPostID) {
      this.$emit('commentitemSubmit', commentPostID, this.commentPostContent)
      this.commentPostContent = ''
    },
    saveClick(PoCmID, PoCmContent) {
      this.readonly = true
      this.showEdit = true
      this.checkidcomment = null

      this.$emit('commentEdit', PoCmID, PoCmContent)
    },
    emitShowDeleteModal(deleteCmId, deleteCmContent, deleteCmPostId, post) {
      this.deleteCmId = deleteCmId
      this.deleteCmContent = deleteCmContent
      this.deleteCmPostId = deleteCmPostId
      this.$emit('showDeleteModal', this.deleteCmId, this.deleteCmContent, this.deleteCmPostId, post)
    },
    closeDeleteModal() {
      this.deleteModalShow = false
    },
    editClick(PoCmID) {
      this.showEdit = false
      this.readonly = false
      this.checkidcomment = PoCmID
    },
    deleteComment() {
      this.$emit('commentDelete', this.deleteCmId, this.deleteCmContent, this.deleteCmPostId)
      this.closeDeleteModal()
    },
    deletePost(post) {
      DataSource.shared.softDeletePost(post.PostID).then(result => {})
      this.sleep(1000) // changes (add for wait a while only delete)
      this.$emit('loadPosts')
    },
    showEditModal() {
      this.$refs.modal_EditComponent.show()
      this.$vs.loading.close()
    },
    hideEditModal() {
      this.obj_SelectedComponent = false
      this.$refs.modal_EditComponent.hide()
    },
    async displayResult(value) {
      if (value === 'TRUE') this.result = 'Successfully posted'
      else this.result = 'Something went wrong. Please inform the adminstrator'

      await this.sleep(300)
      this.hideEditModal()
      this.$emit('loadPosts')
    },
    mouseOver: function () {
      this.isHoverReaction = !this.isHoverReaction
    },
    checkReactionIcon(iconName) {
      let reactionIcon = ''
      // let iconName = reaction.PoReaType;

      if (iconName === 'LIKE') {
        reactionIcon = assets.emotion.like
      } else if (iconName === 'LOVE') {
        reactionIcon = assets.emotion.love
      } else if (iconName === 'WOW') {
        reactionIcon = assets.emotion.wow
      } else if (iconName === 'HAHA') {
        reactionIcon = assets.emotion.funny
      } else if (iconName === 'SAD') {
        reactionIcon = assets.emotion.sad
      }

      return reactionIcon
    },
    checkReactionIconName(iconName) {
      let reactionIconName = ''

      if (iconName === 'LIKE') {
        reactionIconName = lang('LIKE')
      } else if (iconName === 'LOVE') {
        reactionIconName = lang('LOVE')
      } else if (iconName === 'WOW') {
        reactionIconName = lang('WOW')
      } else if (iconName === 'HAHA') {
        reactionIconName = lang('HAHA')
      } else if (iconName === 'SAD') {
        reactionIconName = lang('SAD')
      }

      return reactionIconName
    },
    togglePostReaction(value, e) {
      let reaction = $(e.target).val()
      let isChecked = $(e.target).prop('checked')
      this.obj_SelectedReaction = []

      DataSource.shared
        .updatePostReaction(this.post.PostID, 'DELETE')
        .then(() => {
          if (isChecked) {
            return DataSource.shared.savePostReaction(this.post.PostID, value, 'POST')
          }
        })
        .then(() => {
          DataSource.shared.getPostReaction(this.post.PostID).then(result => {
            // this.$set(this.post, "postReaction", result.Table);
            this.post.postReaction = result.Table
            this.reaction = result.Table
            if (this.post.postReaction !== undefined) {
              this.post.postReaction.forEach(object => {
                if (Cookies.get('userIDSession') === object.PoReaCreatedBy) {
                  this.obj_SelectedReaction.push(object)
                }
              })
            }
            this.$forceUpdate()
          })
          this.$emit('sendMsg', this.post.PostID, this.post.PostContent)
        })
    },
    getUserSelectedReaction(str_Reaction) {
      let isExist = !this.isNull(this.post.postReaction)
        ? this.post.postReaction.filter(x => Cookies.get('userIDSession') === x.PoReaCreatedBy && x.PoReaType.toUpperCase() === str_Reaction).length
        : 0
      return isExist
    },
    mouseOverComment: function (postCommentID) {
      $('#' + postCommentID + '-comment-reaction-list').css('display', 'block')
    },
    mouseLeaveComment: function (postCommentID) {
      $('#' + postCommentID + '-comment-reaction-list').css('display', 'none')
    },
    toggleCommentReaction(e, commentItem) {
      let reaction = $(e.target).val()
      let isChecked = $(e.target).prop('checked')
      this.obj_SelectedCommentReaction = []

      DataSource.shared
        .updatePostReaction(commentItem.PoCmID, 'DELETE')
        .then(() => {
          if (isChecked) {
            return DataSource.shared.savePostReaction(commentItem.PoCmID, reaction, 'POST')
          }
        })
        .then(() => {
          this.$emit('sendMsg', commentItem.PoCmPosID, commentItem.PoCmContent)
        })
    },
    getUserSelectedCommentReaction(str_Reaction, commentItem) {
      let isExist = !this.isNull(commentItem.commentReactions)
        ? commentItem.commentReactions.filter(x => Cookies.get('userIDSession') === x.PoReaCreatedBy && x.PoReaType.toUpperCase() === str_Reaction).length
        : 0
      return isExist
    },
    reactionGroupby(objReaction, key) {
      const result = {}
      objReaction.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    },

    isVideo(obj_File) {
      if (obj_File) {
        let ext = String(obj_File.PostItemFileExt).toUpperCase()
        let isVideo = false

        switch (ext) {
          case '.MP4':
          case '.MOV':
            isVideo = true
            break
          default:
            isVideo = false
            break
        }

        return isVideo
      }
    },
    isPDF(obj_File) {
      if (obj_File) {
        let isPDF = false

        if (obj_File.length > 0) {
          const pdfExist = obj_File.find(d => d.PostItemFileExt.toUpperCase() === '.PDF')
          if (pdfExist) {
            isPDF = true
          }
        } else {
          let ext = String(obj_File.PostItemFileExt).toUpperCase()
          switch (ext) {
            case '.PDF':
              isPDF = true
              break
            default:
              isPDF = false
              break
          }
        }
        return isPDF
      }
    },
    isAudio(obj_File) {
      let ext = String(obj_File.PostItemFileExt).toUpperCase()
      let isAudio = false

      switch (ext) {
        case '.MP3':
        case '.AAC':
        case '.WAV':
        case '.M4A':
          isAudio = true
          break
        default:
          isAudio = false
          break
      }

      return isAudio
    },

    convertDatetimeFormat(orgDate) {
      return moment(orgDate).format('DD/MM/YYYY')
    },

    showReactionModal(length) {
      if (length > 0) {
        this.$refs['reactionModal'].show()
      }
    },
    hideReactionModal() {
      this.$refs['reactionModal'].hide()
    },

    async submitDM(post) {
      // console.log(this.parentDMMsg, "DM msg", postID);
      if (this.parentDMMsg === '') {
        this.$notify.error({
          title: 'Error',
          message: 'Please enter some message!',
        })
        return
      }

      try {
        this.$vs.loading()

        this.singlePostLink = ''

        if (post.PostID !== '') {
          $('.dm-container').css('display', 'none')

          if (post.ProfileImage !== '') {
            $('#profile_' + post.PostID).attr('src', post.oriProfileImage)
          }

          if (!this.isNull(post.postFiles)) {
            post.postFiles.forEach(file => {
              $('#ITEMPOSTID_' + file.PostItemID).attr('src', file.oriFilePath)
            })
          }

          this.singlePostLink = $('.feed-box.' + post.PostID)[0].outerHTML
        }

        const dmResponse = await DataSource.shared.savePostDM(post.PostID, '', this.parentDMMsg, encodeURI(this.singlePostLink))

        if (dmResponse) {
          if (dmResponse.code === '2') {
            this.$notify.error({
              title: 'Error',
              message: 'No record found',
            })
          } else if (dmResponse.code === '88') {
            window.location.replace('/')
          } else if (dmResponse.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Please try again later',
            })
          } else {
            this.$notify({
              title: lang('Success'),
              message: 'Message send successful!',
              type: 'success',
            })
          }
        }

        this.parentDMMsg = ''
        $('.dm-container').css('display', 'block')

        if (post.ProfileImage !== '') {
          $('#profile_' + post.PostID).attr('src', post.ProfileImage)
        }

        if (!this.isNull(post.postFiles)) {
          post.postFiles.forEach(file => {
            $('#ITEMPOSTID_' + file.PostItemID).attr('src', file.FilePath)
          })
        }

        this.$vs.loading.close()
      } catch (e) {
        console.log(e)
      }
    },

    replaceWithLink(val) {
      const URLMatcher =
        /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim

      const withLinks = val.replace(URLMatcher, match => `<a href="${match}" target="_blank">${match}</a>`)
      return withLinks
    },

    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer()
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType })
        })
    },

    showPostSeenModal() {
      this.$refs['postSeenModal'].show()
    },
    hidePostSeenModal() {
      this.$refs['postSeenModal'].hide()
    },
    async generateVideoThumbnail(thumbnail) {
      // let src = thumbnail; ///video url not youtube or vimeo,just video on server
      // let video = document.createElement('video');
      //
      // video.src = src;
      //
      // video.width = 360;
      // video.height = 240;
      //
      // let canvas = document.createElement('canvas');
      // canvas.width = 360;
      // canvas.height = 240;
      // let context = canvas.getContext('2d');
      //
      // context.drawImage(video, 0, 0, canvas.width, canvas.height);
      // let dataURI = canvas.toDataURL('image/jpeg');
      // return dataURI;
    },

    triggerClickVideo(videoFile, itemID) {
      if ($('.video-thumbnail-' + itemID + ' img').length > 0) {
        this.videoClick = true
        $('.video-thumbnail-' + itemID + ' img').remove()

        var video = document.createElement('video')

        video.className = 'video-thumb nonM card-img-top d-block img-fluid w-100'
        video.src = getActivityImageBase(videoFile, true)

        var videoHtml = ''
        videoHtml +=
          "<video class='video-thumb nonM card-img-top d-block img-fluid w-100' style='object-fit: contain; margin: 0px; height: 100%;' controls autoplay src='" +
          videoFile.FilePath +
          "' type='video/mp4' controlsList='nodownload'>"
        // videoHtml += "<source :src='"+videoFile.FilePath+"' type='video/mp4'>";
        videoHtml += '</video>'

        if ($('.video-thumbnail-' + itemID + ' video').length <= 0) {
          $('.video-thumbnail-' + itemID).append(videoHtml)
          this.videoClick = false
        }

        // var filename = videoFile.PostItemID + videoFile.PostItemFileExt;
        // this.urltoFile(videoFile.FilePath, filename, videoFile.PostItemFileType).then((blobFile) => {
        //     var url = window.URL.createObjectURL(blobFile);
        //     // var img = new Image();
        //
        //     videoFile.FilePath = url;
        //
        //     // this.getImagePreviews();
        //     $(".video-thumbnail-"+itemID+" img").remove();
        //
        //     var video = document.createElement('video');
        //
        //     video.className = "video-thumb nonM card-img-top d-block img-fluid w-100";
        //     video.src = videoFile.FilePath;
        //
        //     var videoHtml = "";
        //     videoHtml += "<video class='video-thumb nonM card-img-top d-block img-fluid w-100' style='object-fit: contain; margin: 0px; height: 100%;' controls autoplay src='"+videoFile.FilePath+"' type='video/mp4' controlsList='nodownload'>";
        //     // videoHtml += "<source :src='"+videoFile.FilePath+"' type='video/mp4'>";
        //     videoHtml += "</video>";
        //
        //     if ($(".video-thumbnail-"+itemID+" video").length <= 0) {
        //         $(".video-thumbnail-"+itemID).append(videoHtml);
        //     }
        // }).finally((result) => {
        //     this.videoClick = false;
        // });
      }
    },

    showDivs(type) {
      if (type === 'default') {
        this.currentSlide = this.imgModalSlide + 1
      } else if (type === 'prev') {
        this.currentSlide = this.currentSlide - 1
        if (this.currentSlide < 1) {
          this.currentSlide = this.post.postFiles.length
        }
      } else if (type === 'next') {
        this.currentSlide = this.currentSlide + 1
        if (this.currentSlide > this.post.postFiles.length) {
          this.currentSlide = 1
        }
      }

      this.post.postFiles.forEach((iFiles, iIndex) => {
        iFiles.isSlide = false

        if (this.currentSlide === iIndex + 1) {
          iFiles.isSlide = true
        }
      })
      this.$forceUpdate()
    },
    handleClose() {
      this.modal = null
      this.previewPost = null
    },
    showPreviewModal(post) {
      // if (post.postFiles && post.postFiles.length > 0) {
      //   post.postFiles.forEach(d => {
      //     d.url = d.FilePath;
      //   });
      // }

      if (post.PostType === 'Update') {
        post.PostType = 'Feed'
      }
      post.studentList = this.studentList
      post.classList = this.classList
      post.levelList = this.levelList
      post.school = this.school
      this.previewPost = post
      this.modal = 'preview'
    },
    handleUpdates() {
      // this.$router.push('/NewActivity', this.previewPost)
      this.$router.push({ name: 'NewActivityPage', params: { post: this.previewPost } })
    },
    handleSelectedTags(tags, type) {
      switch (type) {
        case 'student':
          this.studentList = tags
          // this.previewPost.studentList = tags;
          break
        case 'class':
          this.classList = tags
          break
        case 'level':
          this.levelList = tags
          break
        case 'school':
          this.school = tags
          break
      }
    },
    setLoad(value) {},
    handleDownloadPDF(pdf) {
      if (pdf.length > 0) {
        const pdfExist = pdf.filter(d => d.PostItemFileExt.toUpperCase() === '.PDF')

        if (pdfExist) {
          if (pdfExist.length > 0) {
            pdfExist.forEach(url => {
              axios
                .get(url.FilePath, { responseType: 'blob' })
                .then(response => {
                  const blob = new Blob([response.data], { type: 'application/pdf' })
                  const link = document.createElement('a')
                  link.href = URL.createObjectURL(blob)
                  link.download = 'download'
                  link.click()
                  URL.revokeObjectURL(link.href)
                })
                .catch(console.error)
            })
          } else {
            window.open(pdfExist.FilePath, '_blank')
          }
        }
      } else {
        window.open(pdf.FilePath, '_blank')
      }
    },
  },
  created() {
    this.userType = Cookies.get('userTypeSession')

    if (this.userType === 'Parent') {
      let schID = Cookies.get('schoolSession')
      let schIDs = JSON.parse(schID)
      schIDs = schIDs.Table

      this.arr_SchIDs = []
      schIDs.forEach((object, index) => {
        this.arr_SchIDs.push(object.SCH_Ids)
      })
    }

    window.addEventListener('resize', this.isMobile)
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile)
  },
}
</script>
